var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4947",
    "data-name": "Group 4947",
    transform: "translate(-35 -617)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17349",
    "data-name": "Rectangle 17349",
    width: 48,
    height: 48,
    transform: "translate(35 617)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(39.368 619.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H40.132V40.132H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(39.368 623.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(4.048 3.641)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    transform: "translate(7.952 -0.218)",
    fill: "#2d73c7",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M16.143,17.024a12.953,12.953,0,0,1,.162-2,.446.446,0,0,0-.162-.02A22.037,22.037,0,0,0,4.83,18.117,1.864,1.864,0,0,0,4,19.756v1.315H16.73A13.981,13.981,0,0,1,16.143,17.024Z",
    transform: "translate(-4 3.621)",
    fill: "#2d73c7",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M6.048,32.333V31.018a1.914,1.914,0,0,1,.83-1.639A22.037,22.037,0,0,1,18.19,26.262a.446.446,0,0,1,.162.02,13.935,13.935,0,0,1,1.194-4.007c-.445-.04-.89-.061-1.356-.061A26.058,26.058,0,0,0,4.813,25.9,5.914,5.914,0,0,0,2,31.018v5.363H20.74a14.435,14.435,0,0,1-1.963-4.048ZM18.19,20.19a8.1,8.1,0,1,0-8.1-8.1A8.093,8.093,0,0,0,18.19,20.19Zm0-12.143A4.048,4.048,0,1,1,14.143,12.1,4.059,4.059,0,0,1,18.19,8.048Z",
    transform: "translate(-2 -4)",
    fill: "#2d73c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M29.7,14.3l-2.934.992a7.38,7.38,0,0,0-2.186-1.275L23.969,11H19.921l-.607,3.015a7.38,7.38,0,0,0-2.186,1.275L14.194,14.3,12.17,17.8l2.307,2.024a8.78,8.78,0,0,0-.121,1.275,8.779,8.779,0,0,0,.121,1.275L12.17,24.4l2.024,3.5,2.934-.992a7.38,7.38,0,0,0,2.186,1.275l.607,3.056h4.048l.607-3.015a7.38,7.38,0,0,0,2.186-1.275l2.934.992,2.024-3.5-2.307-2.024a8.779,8.779,0,0,0,.121-1.275,8.78,8.78,0,0,0-.121-1.275L31.72,17.84ZM21.945,25.166a4.048,4.048,0,1,1,4.048-4.048A4.059,4.059,0,0,1,21.945,25.166Z",
    transform: "translate(8.412 3.166)",
    fill: "#2d73c7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.e43a2e6a7ac9ccb880278cbc1305d4ce.svg";
export { ForwardRef as ReactComponent };